<template>
    <div>
        <div class="panel-tag mt-3" v-if="!isLoading && Object.keys(orderItems).length == 0">
            {{ $t('table.no_records') }}
        </div>
        <div v-if="!isLoading && Object.keys(orderItems).length != 0" class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <table
                        class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">
                                    {{ tblHeader.label }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, k) in orderItems" :key="'expenses_list_' + k">
                                <td class="align-middle">{{ k + 1 }}</td>
                                <td class="align-middle">
                                    {{ convertTimestampToDate(item.createDate) }}
                                    <br>
                                    {{ convertTimestampToTime(item.createDate) }}
                                </td>
                                <td class="align-middle">
                                    {{ item.name }}
                                </td>
                                <td class="align-middle">
                                    {{ formatPrice(item.amount) }}
                                </td>
                                <td class="align-middle">
                                    {{ formatExpenditureType(item.expenditureType) }}
                                </td>
                                <td class="align-middle">
                                    {{ item.invoice }}
                                </td>
                                <td class="align-middle">
                                    {{ item.remarks }}
                                </td>
                                <td class="align-middle">
                                    <b-button @click="showModal(item)" tabindex="0" variant="outline-primary">
                                        <i class="fal fa-pencil fs-xl"></i>
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment'
import tbl from './../../../../assets/js/dashboard/table-header'
import exp from './../../../../assets/js/dashboard/export-table-header'
import { insertLeadingZero } from './../../../../assets/js/dashboard/utilities.js'
import { getOutletName, handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import { formatPrice } from './../../../../assets/js/dashboard/utilities'


export default {
    name: 'expensesList',
    components: {
    },
    data() {
        return {
            tblHeaders: tbl.orderTblHdr,
            orderItems: {},
            outlet: [],
            isLoading: false,
            mobile: "",
            filterObj: {},

            modalShow: false,
        }
    },
    computed: {
        fields() {
            var fArr = []
            if (this.filterObj.itemType != 'all') {
                fArr.push({ key: "index", label: '#', thClass: 'thead-themed align-middle' })
            }
            var arr = [
                { key: "createDate", label: 'Date & Time' },
                { key: "name", label: 'Name' },
                { key: "amount", label: 'Amount' },
                { key: "expenditureType", label: 'Category' },
                { key: "invoice", label: 'Invoice / Receipt' },
                { key: "remarks", label: 'Remark' },
                { key: "action", label: 'Action' },
            ]
            fArr.push(...arr)
            return fArr
        },
        exportFields() {
            var ret = {}
            ret["#"] = "index"
            ret['Time'] = "createDate"
            ret['Name'] = "name"
            ret['Amount'] = "amount"
            ret["Category"] = "expenditureType"
            ret["Invoice / Receipt"] = "invoice"
            ret["Remark"] = "remarks"
            return ret
        },
    },
    watch: {
        "$i18n.locale"(val) {
            this.setExportData(this.orderItems, this.filterObj)
        }
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price);
        },
        convertTimestampToDate(date) {
            return moment(date * 1000).format(this.$msg.CST.DATE_FORMAT);
        },
        convertTimestampToTime(date) {
            return moment(date * 1000).format(this.$msg.CST.TIME_FORMAT_24);
        },
        getStatusLocalized(t) {
            return this.$i18n.t(t) || t
        },
        getOutletName(id) {
            return getOutletName(id, this.outlet)
        },
        insertLeadingZero(number) {
            return insertLeadingZero(number);
        },
        getDateTime(ts) {
            return moment(ts * 1000).format('DD/MM/YYYY HH:mm:ss')
        },
        formatExpenditureType(text) {
            let list = []
            let temp = text.split('_')
            for (let test of temp) {
                list.push(test.charAt(0).toUpperCase() + test.slice(1))
            }
            return list.join(' ')
        },


        setData(items, filterObj) {
            this.isLoading = false
            this.orderItems = items
            this.filterObj = filterObj
            this.setExportData(this.orderItems, filterObj)
        },
        setExportData(group, filterObj) {
            var exportData = []
            for (var k = 0; k < group.length; k++) {
                var obj = {
                    index: k + 1,
                    createDate: this.getDateTime(group[k].createDate),
                    name: group[k]['name'],
                    amount: formatPrice(group[k]['amount']),
                    expenditureType: this.formatExpenditureType(group[k]['expenditureType']),
                    invoice: group[k]['invoice'],
                    remarks: group[k]['remarks'],
                }

                exportData.push(obj)
            }

            var strDate = moment(filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_expenses`)
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_expenses`),
                this.$i18n.t('table.header.date') + ": " + strDate,
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),
                this.$i18n.t('label.outlet') + ": " + (filterObj.outlet.id == "all" ? this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) : filterObj.outlet.text),
                " "];
            var exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV

            var data = {
                exportData: exportData,
                exportHeaders: exportHeaders,
                exportFileName: exportFileName,
                exportFields: this.exportFields
            }
            this.$emit('setExportData', data)
        },

        generateReceipt(salesID) {
            const QUERY_STRING = "/" + salesID + this.$api.RECEIPT
            const url = this.$api.REPORT_SALES + QUERY_STRING;

            let $vm = this
            this.$axios({
                method: 'get',
                url: url,
                baseURL: this.$axios.defaults.baseURL,
                headers: { token: this.$util.getSessionToken() }
            })
                .then(function (response) {
                    if (response.status == 200) {
                        var path = response.data.path;
                        window.open(path, '_blank');
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        showModal(item) {
            this.$emit('editExpenditure', item)
        },
    },
    mounted() {
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
    }
}
</script>
<style scoped>
.show {
    display: block;
}
</style>
<style>
.nav-link,
.link {
    cursor: pointer;
}

.link>i {
    font-size: large;
}

.modal-body {
    max-height: 65vh;
    overflow-y: auto;
}

.modal-lg {
    max-width: 1000px;
}

.width-12 {
    width: 12%;
}
</style>